<div class="register-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    <div class="card register-card">
      <div class="card-header">
        <h2>Crear Cuenta</h2>
      </div>

      <div class="card-body">
        <!-- Success - prominent activation steps -->
        @if (successMessage) {
          <div class="activation-modal">
            <div class="activation-icon">
              <svg viewBox="0 0 64 64" width="64" height="64" fill="none">
                <circle cx="32" cy="32" r="30" stroke="#22C55E" stroke-width="3"/>
                <path d="M20 32l8 8 16-16" stroke="#22C55E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            <h3 class="activation-title">Cuenta creada</h3>

            <div class="activation-steps">
              <div class="step">
                <span class="step-number">1</span>
                <div class="step-text">
                  <strong>Revisa tu email</strong>
                  <p>Hemos enviado un enlace de activacion a <strong>{{ registeredEmail }}</strong></p>
                </div>
              </div>
              <div class="step">
                <span class="step-number">2</span>
                <div class="step-text">
                  <strong>Haz clic en el enlace</strong>
                  <p>Abre el email y pulsa el boton de activacion</p>
                </div>
              </div>
              <div class="step">
                <span class="step-number">3</span>
                <div class="step-text">
                  <strong>Crea tu contrasena</strong>
                  <p>Elige una contrasena segura para completar el registro</p>
                </div>
              </div>
            </div>

            <div class="activation-warning">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <span>El enlace expira en 48 horas. Revisa tambien la carpeta de spam.</span>
            </div>

            @if (error) {
              <div class="error-message global-error" style="margin-bottom: 12px;">
                {{ error }}
              </div>
            }

            <button
              type="button"
              class="btn btn-outline btn-block"
              [disabled]="resendCooldown > 0 || resendLoading"
              (click)="resendActivation()"
              style="margin-bottom: 12px;"
            >
              @if (resendLoading) {
                <span>Reenviando...</span>
              } @else if (resendCooldown > 0) {
                <span>Reenviar en {{ resendCooldown }}s</span>
              } @else {
                <span>Reenviar email de activacion</span>
              }
            </button>

            <a routerLink="/login" class="btn btn-primary btn-block">Ir al login</a>
          </div>
        } @else {
          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form">
            <div class="form-group">
              <label for="name">Nombre</label>
              <input
                type="text"
                id="name"
                formControlName="name"
                class="form-control"
                [class.is-invalid]="f['name'].invalid && f['name'].touched"
                placeholder="Tu nombre completo"
              >
              @if (f['name'].invalid && f['name'].touched) {
                <div class="error-message">
                  @if (f['name'].errors?.['required']) {
                    <span>Nombre es requerido</span>
                  }
                  @if (f['name'].errors?.['minlength']) {
                    <span>Nombre debe tener al menos 2 caracteres</span>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-control"
                [class.is-invalid]="f['email'].invalid && f['email'].touched"
                placeholder="tu&#64;email.com"
              >
              @if (f['email'].invalid && f['email'].touched) {
                <div class="error-message">
                  @if (f['email'].errors?.['required']) {
                    <span>Email es requerido</span>
                  }
                  @if (f['email'].errors?.['email']) {
                    <span>Email invalido</span>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  formControlName="acceptTerms"
                  class="form-check-input"
                  [class.is-invalid]="f['acceptTerms'].invalid && f['acceptTerms'].touched"
                >
                <label for="acceptTerms" class="form-check-label">
                  Acepto los <a href="/terms" target="_blank">terminos y condiciones</a> y la <a href="/privacy" target="_blank">politica de privacidad</a>
                </label>
              </div>
              @if (f['acceptTerms'].invalid && f['acceptTerms'].touched) {
                <div class="error-message">
                  <span>Debes aceptar los terminos y condiciones</span>
                </div>
              }
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  type="checkbox"
                  id="marketingConsent"
                  formControlName="marketingConsent"
                  class="form-check-input"
                >
                <label for="marketingConsent" class="form-check-label">
                  Quiero recibir ofertas y promociones por email (opcional)
                </label>
              </div>
            </div>

            @if (error) {
              <div class="error-message global-error">
                {{ error }}
              </div>
            }

            <button
              type="submit"
              class="btn btn-primary btn-block btn-lg"
              [disabled]="loading || registerForm.invalid"
            >
              @if (loading) {
                <span>Registrando...</span>
              } @else {
                <span>Crear Cuenta</span>
              }
            </button>
          </form>
        }
      </div>

      <div class="card-footer">
        <div class="login-link">
          <p>Ya tienes cuenta? <a routerLink="/login" class="login-link-text">Inicia sesion aqui</a></p>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirmation Modal: shown before sending registration -->
  @if (showConfirmModal) {
    <div class="confirm-overlay" (click)="closeConfirmModal()"></div>
    <div class="confirm-modal">
      <button type="button" class="confirm-close" (click)="closeConfirmModal()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>

      <div class="confirm-icon">
        <svg viewBox="0 0 64 64" width="52" height="52" fill="none">
          <rect x="12" y="8" width="40" height="48" rx="4" stroke="#22C55E" stroke-width="2.5"/>
          <path d="M20 24h24M20 32h24M20 40h14" stroke="#22C55E" stroke-width="2" stroke-linecap="round"/>
          <circle cx="48" cy="48" r="14" fill="#111" stroke="#22C55E" stroke-width="2.5"/>
          <path d="M43 48l3 3 7-7" stroke="#22C55E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <h3 class="confirm-title">Importante: Revisa tu email</h3>

      <p class="confirm-message">
        Al crear tu cuenta, te enviaremos un <strong>enlace de activacion</strong> al email:
      </p>

      <div class="confirm-email">{{ registerForm.value.email }}</div>

      <div class="confirm-steps">
        <div class="confirm-step">
          <span class="cs-num">1</span>
          <span>Recibiras un email con un enlace</span>
        </div>
        <div class="confirm-step">
          <span class="cs-num">2</span>
          <span>Haz clic en el enlace para crear tu contrasena</span>
        </div>
        <div class="confirm-step">
          <span class="cs-num">3</span>
          <span>Solo entonces tu cuenta estara activa</span>
        </div>
      </div>

      <div class="confirm-alert">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#22C55E" stroke-width="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <span>Sin hacer clic en el enlace del email, <strong>no podras iniciar sesion</strong>.</span>
      </div>

      <!-- Turnstile widget inside the modal -->
      <div id="turnstile-register" class="turnstile-container"></div>

      <div class="confirm-actions">
        <button
          type="button"
          class="btn btn-outline btn-block"
          (click)="closeConfirmModal()"
          [disabled]="loading"
        >
          Volver
        </button>
        <button
          type="button"
          class="btn btn-primary btn-block"
          (click)="confirmRegister()"
          [disabled]="loading"
        >
          @if (loading) {
            <span>Registrando...</span>
          } @else {
            <span>Entendido, crear cuenta</span>
          }
        </button>
      </div>
    </div>
  }
</div>
